import { EAlertVariants, IAlert } from 'components/atoms/Alert';
import { IReducerAction } from 'models/context';
import { EActionTypes } from 'state/actions/account';

interface IState {
  createMessage: IAlert;
  isCreateLoading: boolean;
}

export const initialState: IState = {
  createMessage: {
    text: '',
    variant: EAlertVariants.success,
  },
  isCreateLoading: false,
};

export const reducer = (state: IState, { type, payload }: IReducerAction) => {
  switch (type) {
    case EActionTypes.CREATE_ACCOUNT: {
      return {
        ...state,
        isCreateLoading: true,
      };
    }
    case EActionTypes.CREATE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        createMessage: {
          text: '',
          variant: EAlertVariants.success,
        },
        isCreateLoading: false,
      };
    }
    case EActionTypes.CREATE_ACCOUNT_FAILURE: {
      return {
        ...state,
        createMessage: payload?.createMessage || state.createMessage,
        isCreateLoading: false,
      };
    }
    case EActionTypes.CLEAR_ACCOUNT_ERRORS: {
      return {
        ...state,
        createMessage: { text: '', variant: EAlertVariants.success },
      };
    }

    default:
      return state;
  }
};
